import {RumTimeMark, sendRumTimeMark} from '@logistics-frontend/modules/rum'
import {applyPolyfills} from '@logistics-frontend/polyfills'
import {StrictMode, useEffect} from 'react'
import {createRoot} from 'react-dom/client'

import {__HTML_ROOT__} from './config/consts'
import Page from './Page.client'

sendRumTimeMark(RumTimeMark.BEFORE_JS_FRAMEWORK_INIT)

function App() {
  useEffect(() => {
    sendRumTimeMark(RumTimeMark.REACT_INITED)
  }, [])

  return <Page />
}

applyPolyfills().then(() =>
  createRoot(document.getElementById(__HTML_ROOT__)!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  ),
)

sendRumTimeMark(RumTimeMark.JS_FRAMEWORK_INITED)
